import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../lib/supabase';

export interface BookingData {
  id: number;
  eta: string | null;
  status: string;
  reference: string;
  company_id: number;
  created_at: string;
  origin_port: number;
  supplier_id: number;
  booking_type?: number;
  transport_type: number;
  track_and_trace: string | null;
  booking_incoterm: number;
  destination_port: number | null;
  origin_pickup_date: string;
  commercial_invoice_file: string | null;
  [key: string]: string | number | null | undefined;
}

interface ChangeData {
  old: BookingData;
  new: BookingData;
}

export interface BookingNotification {
  id: number;
  created_at: string;
  booking_id: number;
  change_data: ChangeData;
}

export const useNotifications = (bookingId: string) => {
  const [notifications, setNotifications] = useState<BookingNotification[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchNotifications = useCallback(async () => {
    try {
      const { data, error } = await supabase
        .from('notifications')
        .select('*')
        .eq('booking_id', bookingId)
        .order('created_at', { ascending: true });

      if (error) throw error;

      setNotifications(data || []);
    } catch (err) {
      console.error('Error fetching notifications:', err);
      setError(err instanceof Error ? err.message : 'Failed to fetch notifications');
    } finally {
      setLoading(false);
    }
  }, [bookingId]);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  return { notifications, loading, error };
}; 